import {useFileHistoryStore} from "@/stores/useFileHistoryStore.ts";
import {computed, type MaybeRefOrGetter, ref, toValue} from "vue";
import type {HistoryEntry} from "@/services/historyDb.ts";

export function useFileHistoryActionButtons(entry: MaybeRefOrGetter<HistoryEntry>) {
    const isBusy = ref(false);

    async function withBusy(fn: () => Promise<void>) {
        if (isBusy.value) return;
        isBusy.value = true;
        try {
            await fn();
        } finally {
            isBusy.value = false;
        }
    }

    const historyStore = useFileHistoryStore();

    // Wiederverwenden wechselt zum Konvertieren-Tab – das übernimmt der
    // [fileInfo, selectedFileContent]-Watcher im useTabStore (reuse lädt neuen Inhalt).
    // Download/Löschen ändern keinen Inhalt und bleiben damit im Verlauf-Tab (der frühere
    // Wechsel im withBusy-finally traf fälschlich ALLE Aktionen).
    function onReuse() {
        void withBusy(() => historyStore.reuse(toValue(entry)));
    }

    function onDownload() {
        void withBusy(() => historyStore.download(toValue(entry)));
    }

    function onDelete() {
        void withBusy(() => historyStore.remove(toValue(entry).id));
    }

    function onSelect() {
        historyStore.select(toValue(entry).id);
    }

    function onOpenInNewTab() {
        historyStore.openInNewTab(toValue(entry));
    }

    return {
        onDelete,
        onDownload,
        onSelect,
        onReuse,
        onOpenInNewTab,
        isBusy,
        isSelected: computed(() => historyStore.selectedId === toValue(entry).id || historyStore.selectedId === toValue(entry).sourceFileId)
    };

}